import { IconHomeDark } from '@/components/Icon/HeaderIcon'
import { SearchBar } from '@/components/SearchBar'
import { useRouterBack } from '@/hooks/useRouterBack'
import { IconBackDark } from '@/styles/Icon'
import Link from 'next/link'

const HeaderSearch = () => {
  const handleGoBack = useRouterBack()
  return (
    <div className='max-w-[440px] sticky top-0 left-0 flex z-[99] h-[60px] items-center justify-between w-full gap-2 px-1'>
      <div className='relative max-w-[40px] flex-[40px]'>
        <button
          className='h-10 w-10 outline-none flex justify-center items-center cursor-pointer relative z-10'
          onClick={() => handleGoBack(true)}
        >
          <IconBackDark />
        </button>
      </div>

      <div className='rounded-full w-full p-[2px] bg-primary-base'>
        <div className='flex items-center h-[38px] justify-between bg-white text-white rounded-[100px] pr-[4px] pl-[12px]'>
          <SearchBar />
        </div>
      </div>
      <div className='relative max-w-[40px] flex-[40px]'>
        <Link
          className='h-10 w-10 outline-none flex justify-center items-center'
          href={'/'}
        >
          <IconHomeDark />
        </Link>
      </div>
    </div>
  )
}
export default HeaderSearch
